import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconBranch = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 448 512" size={size}>
      <path d="M448 80C448 35.82 412.2 0 368 0C323.8 0 288 35.82 288 80c0 32.79 19.77 60.89 48 73.25V192c0 17.66-14.36 32-32 32h-160c-11.28 0-21.94 2.312-32 5.898V153.2C140.2 140.9 160 112.8 160 80C160 35.82 124.2 0 80 0C35.82 0 0 35.82 0 80c0 32.79 19.77 60.89 48 73.25v205.5C19.77 371.1 0 399.2 0 432C0 476.2 35.82 512 80 512C124.2 512 160 476.2 160 432c0-32.79-19.77-60.89-48-73.25V320c0-17.66 14.36-32 32-32h160c52.94 0 96-43.06 96-96V153.2C428.2 140.9 448 112.8 448 80zM80 56c13.23 0 24 10.77 24 24S93.23 104 80 104c-13.23 0-24-10.77-24-24S66.77 56 80 56zM80 456c-13.23 0-24-10.77-24-24s10.77-24 24-24c13.23 0 24 10.77 24 24S93.23 456 80 456zM368 56c13.23 0 24 10.77 24 24s-10.77 24-24 24c-13.23 0-24-10.77-24-24S354.8 56 368 56z">
      </path>
    </BaseIcon>
  );
}

export default IconBranch;
